import { render } from "./AddResource.vue?vue&type=template&id=06982ed3"
import script from "./AddResource.vue?vue&type=script&lang=js"
export * from "./AddResource.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__